

export class DateHelper {

    public static toTimestamp(dateStr) {
        // Conversion vers le format date BDD
        console.log(dateStr);
        if (!dateStr) return null;
        if (dateStr.length < 10) return null;
        const year = dateStr.substring(6, 10);
        const month = dateStr.substring(3, 5);
        const day = dateStr.substring(0, 2);
        // console.log("annee mois jour",year,month,day);
        return new Date(year, month - 1, day);
    }
    public static timestampToDefault(value, withDate = true, withHour = true) {
        if (!value) return '';

        const date = new Date(parseInt(value));
        // return date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear();
        return (withDate ? date.toLocaleDateString() + ' ' : '') + (withHour ? date.toLocaleTimeString() : '');
    }
    public static toDateTime(value) {
        if (!value) return '';

        const date = new Date(parseInt(value));
        // return date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear();
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    }

    public static completeDecimalA2Chiffrees(value) {
        return value.toString().replace(/^(\d)$/, '0$1');
    }
    public static decimalHoursToHoursMin(value) {
        if (!value) return '';

        const hours = this.completeDecimalA2Chiffrees(Math.floor(value));
        const mins = this.completeDecimalA2Chiffrees(Math.round((value - hours) * 60));
        // console.log({ou: 'decimalHoursToHoursMin', value, hours, mins});
        return `${hours}H${mins}`;
    }
    /**
     * 
     * @param value Converti un horaire au format 00h00 ou 00H00 en un nombre d'heures décimal
     * (10h30 = 10,5 ; 5H45 = 5,75 ...)
     */
    public static horaireToHeureDecimal(value: string) {
        const valueUpperCase = value.toUpperCase();
        if (!valueUpperCase.includes('H')) {
            // pas de minutes, seulement des heures
            const hhh = parseInt(valueUpperCase);
            return hhh;
        }
        // Présence de H dans value
        const [hh, mm] = valueUpperCase.split('H');
        let h = parseInt(hh);
        h = isNaN(h) ? 0 : h;
        let m = parseInt(mm);
        m = isNaN(m) ? 0 : m;
        const horaireDecimal = h + (m / 60);
        return horaireDecimal;
    }
    public static minutesToHoursMin(value) {
        if (!value) return '';

        const hours = Math.floor(value / 60);
        const hoursStr = this.completeDecimalA2Chiffrees(hours);
        const mins = value % 60;
        const minsStr = this.completeDecimalA2Chiffrees(mins);
        return `${hoursStr}H${minsStr}`;
    }

    public static toDate(value) {
        return Date.parse(value);
    }
    public static toDateString(value) {
        const date = Date.parse(value);
        // console.log("Provenant de BDD",value,date);
        return this.timestampToDefault(date);
    }
    public static dateBDD2Date(dateStr) {
        if (!dateStr) return null;
        if (!dateStr.length || dateStr.length < 10) return null;
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(5, 7);
        const day = dateStr.substring(8, 10);
        // console.log("annee mois jour",year,month,day);
        return new Date(year, month - 1, day);
    }
    public static dateBDD2String(dateStr) {
        // console.log({ ou: 'dateBDD2String', dateStr});
        const d = this.dateBDD2Date(dateStr);
        if (d) {
            return d.toLocaleDateString();
        } else {
            return '';
        }
    }

    public static age(dateNaissance, dateCalcul= new Date) {
        if (dateNaissance === null) {
            return 0;
        }
        if ((typeof dateNaissance) === 'string') {
            dateNaissance = this.dateBDD2Date(dateNaissance);
        }
        if ((typeof dateCalcul) === 'string') {
            dateCalcul = this.dateBDD2Date(dateCalcul);
        }
        const naissAnnee = dateNaissance.getFullYear();
        const naissMois = dateNaissance.getMonth(); // janvier=0
        const naissJour = dateNaissance.getDate();
        let age = dateCalcul.getFullYear() - naissAnnee;
        if (naissMois > dateCalcul.getMonth())
        {
            // age+=1;
        } else if (naissMois === dateCalcul.getMonth() && naissJour >= dateCalcul.getDate())
        {
            // age += 1;
        } else {
            age -= 1;
        }
        return age;
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/helpers/date.helper.ts